module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/27-8e66c8c98f73785516de984ab275f1c0.jpg";